import React from "react";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "../ui/Collapsible";
import { INSPECTOR_SECTION_TITLE_TO_BODY_PAD_CLASS } from "../../utils/inspectorChromeButtonClasses";
import BodyAddInlineMenu from "./BodyAddInlineMenu";
import InspectorPhysicsLockedCollapsibleWrap from "./InspectorPhysicsLockedCollapsibleWrap";

const BodyQuickAddSection = React.memo(function BodyQuickAddSection({
  allowRootBody = false,
  bodies,
  bodyName,
  bodyUuid,
  cameras,
  disabled,
  equalities,
  hasInertia,
  sceneActions,
  title = "Quick Add",
}) {
  return (
    <InspectorPhysicsLockedCollapsibleWrap locked={disabled}>
      <Collapsible defaultOpen>
        <CollapsibleTrigger quiet>{title}</CollapsibleTrigger>
        <CollapsibleContent>
          <div className={INSPECTOR_SECTION_TITLE_TO_BODY_PAD_CLASS}>
            <BodyAddInlineMenu
              allowRootBody={allowRootBody}
              bodyUuid={bodyUuid}
              bodyName={bodyName}
              bodies={bodies}
              cameras={cameras}
              equalities={equalities}
              hasInertia={hasInertia}
              disabled={disabled}
              sceneActions={sceneActions}
            />
          </div>
        </CollapsibleContent>
      </Collapsible>
    </InspectorPhysicsLockedCollapsibleWrap>
  );
});

export default BodyQuickAddSection;
